// Determina la struttura in cui si trovava un ospite in un dato mese (YYYY-MM),
// usando lo storico dei trasferimenti. Per i mesi precedenti al primo trasferimento
// restituisce la struttura di origine; dal mese di decorrenza in poi la nuova.
export const structForMonth = (o, ym) => {
  if (!o) return undefined;
  if (!ym) return o.structure_id;
  const tr = (o.trasferimenti || [])
    .filter((t) => t && t.dal_mese)
    .slice()
    .sort((a, b) => (a.dal_mese || "").localeCompare(b.dal_mese || ""));
  if (!tr.length) return o.structure_id;
  let s = tr[0].da_structure_id || o.structure_id;
  for (const t of tr) { if (ym >= t.dal_mese) s = t.a_structure_id; }
  return s || o.structure_id;
};
